<div class="list-page" style="min-height: 100vh; display: flex; justify-content: space-between; flex-direction: column">
  <div>
    <app-asiakas-otsikko otsikko="Lataa tositteita" paluuUrl="/asiakkaat" [asiakas]="asiakasObservable | async"></app-asiakas-otsikko>

    @if (kirjanpitajaOnDevaajaObservable | async) {
      <div style="padding-bottom: 20px">
        <h3 style="margin: 0">Urit</h3>
        <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
          Kuitit (Lemonaid): <a [href]="kuititEncodedUriObservable | async" target="_BLANK">{{ kuititUriObservable | async }}</a>
        </div>
        <div style="padding-top: 0em; padding-left: 1em; padding-right: 1em">
          Laskut (Lemonaid): <a [href]="laskutEncodedUriObservable | async" target="_BLANK">{{ laskutUriObservable | async }}</a>
        </div>
        <div style="padding-top: 0em; padding-left: 1em; padding-right: 1em">
          Kuukausikortit (Lemonator): <a [href]="kuukausisummakortitEncodedUriObservable | async" target="_BLANK">{{ kuukausisummakortitUriObservable | async }}</a>
        </div>
      </div>
    }

    <div style="display: flex; align-items: top; justify-content: space-between">
      <div>
        <h4>Lataa palkkatositteet</h4>
        <form>
          <mat-form-field style="width: 150px">
            <mat-label>Kuukausi</mat-label>
            <mat-select [formField]="lomake.selectedMonthZip">
              @for (month of selectableMonths; track month) {
                <mat-option [value]="month">
                  {{ month | numbermonthtomonthyear | async }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </form>
        <app-primary-button (click)="downloadSalaryZip()" actionId="Lataa palkkatosite koneelle" [actionContext]="[lomake.selectedMonthZip().value()]"> Download </app-primary-button>
      </div>
      @if (isSuperUserObservable | async) {
        <div>
          <h4>Käynnistä palkkojen haku</h4>
          <form>
            <mat-form-field style="width: 150px">
              <mat-label>Kuukausi</mat-label>
              <mat-select [formField]="lomake.selectedMonthFetch">
                @for (month of selectableMonths; track month) {
                  <mat-option [value]="month">
                    {{ month | numbermonthtomonthyear | async }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </form>
          <app-primary-button (click)="fetchSalaryFromPalkkausfi()" actionId="Käynnistä palkkojen haku" [actionContext]="[lomake.selectedMonthFetch().value()]"> Käynnistä </app-primary-button>
          @if (isTrustedUserObservable | async) {
            <app-primary-button (click)="fetchSalaryFromPalkkausfiSuoriteperusteinen()" actionId="Käynnistä palkkojen haku" [actionContext]="[lomake.selectedMonthFetch().value()]"> SUORITEPERUSTEINEN </app-primary-button>
          }
        </div>
      }
      <mat-form-field style="width: 150px">
        <mat-label>Näytä</mat-label>
        <mat-select #naytaKaikki>
          <mat-option [value]="false"> Uudet tositteet </mat-option>
          <mat-option [value]="true"> Kaikki tositteet </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="kuukaudet-container">
      <div lemon-loading [show]="ladataanKuukausiaObservable | async"></div>
      @if (eiUusiaTositteitaObservable | async) {
        <div style="display: flex; align-items: center">
          <span>Asiakkaalla ei ole <b>uusia</b> tositteita</span>
        </div>
      }
      @if (eiTositteitaObservable | async) {
        <div style="display: flex; align-items: center">
          <span>Asiakkaalla ei ole yhtään tositetta</span>
        </div>
      }
      @if (!(ladataanKuukausiaObservable | async)) {
        @for (kuukausi of kuukaudetObservable | async; track kuukausi) {
          <div class="mat-elevation-z3 kuukausi-container">
            <div class="light-blue-text kk-otsikko">
              {{ kuukausi.vuosi }}/{{ kuukausi.kk > 9 ? kuukausi.kk : '0' + kuukausi.kk }}
              @if (kuukausi.lataamatta === 0) {
                <mat-icon class="green-text">check</mat-icon>
              }
            </div>
            <!-- Lataamatta: {{kuukausi.lataamatta}}, Ladattu: {{kuukausi.ladattuja}}, Yhteensä {{kuukausi.ladattuja + kuukausi.lataamatta}} -->
            <table class="gray-text">
              @for (maksutapa of kuukausi.maksutavoittain; track maksutapa) {
                <tr [class.light-gray-text]="1 > maksutapa.ladattuja + maksutapa.lataamatta">
                  <td>{{ maksutapa.maksutavanNimi }}</td>
                  <td style="text-align: right; font-weight: bold" class="blue-text">{{ maksutapa.lataamatta > 0 ? maksutapa.lataamatta : '' }}</td>
                  <td style="text-align: right">{{ maksutapa.ladattuja + maksutapa.lataamatta }}</td>
                </tr>
              }
              <tr [class.light-gray-text]="1 > kuukausi.ladattuja + kuukausi.lataamatta">
                <td>Yhteensä</td>
                <td style="text-align: right; font-weight: bold" class="blue-text">{{ kuukausi.lataamatta > 0 ? kuukausi.lataamatta : '' }}</td>
                <td style="text-align: right">{{ kuukausi.ladattuja + kuukausi.lataamatta }}</td>
              </tr>
            </table>
            <div style="display: flex; justify-content: space-between">
              <app-button [disabled]="1 > kuukausi.lataamatta" (click)="lataaUudet(kuukausi)" actionId="Lataa uudet tositteet koneelle" [actionContext]="[kuukausi]" [dynamicClass]="{ 'blue-text': kuukausi.lataamatta > 0, 'light-gray-text': 1 > kuukausi.lataamatta }" styles="font-weight: bold;"> Lataa uudet </app-button>
              <app-button (click)="lataaKaikki(kuukausi)" actionId="Lataa kaikki tositteet koneelle" [actionContext]="[kuukausi]" additionalClass="gray-text"> Lataa kaikki </app-button>
            </div>
          </div>
        }
      }
    </div>
  </div>

  <div style="display: flex; justify-content: flex-end; margin-top: 2em; margin-bottom: 2em">
    <app-secondary-button (click)="naytaHistoria()" actionId="Näytä tositteiden lataushistoria" matIcon="history"> Lataushistoria&nbsp; </app-secondary-button>
  </div>
</div>
